// ----------------------------------------------------------------------------
// Сохранение чего-то в ЛК (вспомогательные функции)
// ----------------------------------------------------------------------------



import {removeElements} from "../auth-common/auth-misc-functions.js";
import {accountElements, authElements} from "../auth-common/auth-account-elements.js";



export function saveAvatarHelp() {
    const form = document.getElementById('ttAvatar_form');

    if (!form || !authElements.ttAuthAva) return;

    // Имитируем клик по скрытому инпуту для вызова окна выбора файла
    authElements.ttAuthAva.click();

    // Вешаем слушатель изменения на инпут
    authElements.ttAuthAva.onchange = function() {

        // Проверяем, что пользователь действительно выбрал файл, а не просто закрыл окно
        if (this.files && this.files.length > 0) {
            removeElements('.g-message');
            if (accountElements.accountHeader) {
                accountElements.accountHeader.insertAdjacentHTML(
                    'afterend',
                    '<div class="g-message">Обработка данных...</div>'
                );
            }
            form.submit();
        }
    };
}